import ClientList from './List';
import ClientForm from './Form';
import PolicyList from './policy/List';
import PolicyForm from './policy/Form';

export default {
    path: 'cadastros',
    redirect: '/cadastros/clientes',
    name: 'Cadastro Clientes',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    children: [
        {
            path: 'clientes',
            name: 'list-client',
            component: ClientList,
            meta: {
                requiresAuth: true,
                label: 'Listar Clientes'
            }
        },
        {
            path: 'clientes/novo',
            name: 'new-client',
            component: ClientForm,
            meta: {
                requiresAuth: true,
                label: 'Novo Cliente'
            }
        },
        {
            path: 'clientes/:id',
            name: 'edit-client',
            component: ClientForm,
            meta: {
                requiresAuth: true,
                label: 'Editar Cliente'
            }
        },
        {
            path: 'clientes/:id/apolices',
            name: 'list-policies',
            component: PolicyList,
            meta: {
                requiresAuth: true,
                label: 'Listar Apólices'
            }
        },
        {
            path: 'clientes/:id/apolices/:idPolicy',
            name: 'edit-policies',
            component: PolicyForm,
            meta: {
                requiresAuth: true,
                label: 'Visualizar Apólice'
            }
        },
    ],

}



// WEBPACK FOOTER //
// ./src/views/client/router.js